import { render, staticRenderFns } from "./ReplacementItemReorderEnable.vue?vue&type=template&id=a108a802"
import script from "./ReplacementItemReorderEnable.vue?vue&type=script&lang=js"
export * from "./ReplacementItemReorderEnable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports